module.exports = __webpack_public_path__ + "static/media/Slice_2.c496a0e5.png";